import * as React from "react";
import type { SVGProps } from "react";
const SvgWifi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      fill="#D65B4B"
      d="M6.75 9.563a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m4.482-5.63a8.25 8.25 0 0 0-10.464 0 .563.563 0 0 0 .714.87 7.125 7.125 0 0 1 9.036 0 .563.563 0 0 0 .714-.87M9.724 5.608a6 6 0 0 0-7.448 0 .563.563 0 0 0 .698.882 4.875 4.875 0 0 1 6.052 0 .562.562 0 0 0 .698-.882M8.206 7.28a3.75 3.75 0 0 0-4.412 0 .563.563 0 1 0 .662.91 2.625 2.625 0 0 1 3.088 0 .563.563 0 1 0 .662-.91"
    />
  </svg>
);
export default SvgWifi;
